import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select'; // Import react-select
import AsyncSelect from 'react-select/async';

function LedgerReport() {
    const [dataBill, setDataBill] = useState([]);
    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [selectedOption, setSelectedOption] = useState('itemWise');
    const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [customerId, setCustomer] = useState('');
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate } = useAuth();


    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
    }, [isAuthenticated, companyId, token, branchId, logout]);


    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };


    const getFormattedStartDate = () => {
        const today = new Date();
        let year = today.getFullYear();

        if (today.getMonth() + 1 > 3) {
            // If the current month is greater than 3, use the current year
            return `${year}-04-01`;
        } else {
            // If the current month is 3 or less, use the previous year
            return `${year - 1}-04-01`;
        }
    };
    //FOR CHILD 
    const [ChildOptions, setchildOptions] = useState([]);
    const [selectedChildOption, setSelectedChildOption] = useState(null);

    const fetchChildOptions = async (inputValue) => {
        if (inputValue.length <= 3) {
            return [];
        }

        try {
            const response = await fetchData('ReportApi', `/Master/${companyId}/${branchId}/${inputValue}`, token);
            if (response.responseCode === '1111') {
                const data = await response.response_data;

                if (Array.isArray(data)) {
                    setchildOptions(data); // Save the options for later use
                    return data.map(item => ({
                        value: item.Id,
                        label: item.Name,
                    }));
                } else {
                    console.error('Data is not an array:', data);
                    return [];
                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
                return [];
            }
        } catch (error) {
            console.error('Error fetching options:', error);
            return [];
        }
    };
    const handleChildInputChange = (newValue) => newValue;
    // Handle customer selection
    const handleChildSelect = (selectedChildOption) => {
        setSelectedChildOption(selectedChildOption);

    };


    const [errorMessage, setErrorMessage] = useState('');

    const fetchTableData = async () => {
        if (!selectedChildOption || !selectedChildOption.value) {
            setErrorMessage('Please select a master.');
            return;
        }

        setErrorMessage('');
        setDataItem([]);
        try {
            const response = await fetchData('ReportApi', `/Ledger/${companyId}/${branchId}/${selectedChildOption.value}/${fromDate}/${toDate}`, token);

            if (response.responseCode === '1111') {
                setDataItem(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Report Details:', error);
        }
    };


    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setFromDate(selectedDate);
    };

    // Similar function for toDate
    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setToDate(selectedDate);
    };

    const hasReadReportPermission = permissions.includes('Read Reports');

    const handleChange = (event) => {
        setSelectedOption(event.target.value);
    };



    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataBill = dataBill.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const filteredDataItem = dataItem.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };


    const handleExportExcel = () => {
        const excelData = [];

        // Ensure selectedCustomer is handled properly
        const customerLabel = selectedChildOption ? selectedChildOption.label : 'All Customers';

        // Add header caption
        const headerCaption = [
            `Ledger for ${customerLabel} From: ${formatDate(fromDate)} To: ${formatDate(toDate)}`
        ];
        excelData.push(headerCaption);

        // Add column headers
        const headerRow = ['Date', 'Description', 'Debit', 'Credit'];
        excelData.push(headerRow);

        // Add data rows
        filteredDataItem.forEach((rowData) => {
            const dataRow = [];
            if (rowData.description1 === 'Opening Balance' || rowData.description1 === 'Closing Balance') {
                // Display balances under Debit and Credit columns
                dataRow.push(
                    '', // Empty date
                    rowData.description1,
                    rowData.debit || '',
                    rowData.credit || ''
                );
            } else if (rowData.description1 === 'Total') {
                // Display Total directly under Debit and Credit columns
                dataRow.push(
                    '', // Empty date
                    rowData.description1,
                    rowData.debit || '',
                    rowData.credit || ''
                );
            } else {
                // For regular rows
                dataRow.push(
                    formatDate(rowData.date1),
                    rowData.description1,
                    rowData.debit || '',
                    rowData.credit || ''
                );
            }
            excelData.push(dataRow);
        });

        // Use XLSX library to create and download the Excel file
        const worksheet = XLSX.utils.aoa_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Ledger');

        // Filename sanitization for spaces and special characters
        const sanitizedCustomerLabel = customerLabel.replace(/[^\w]/g, '_');
        XLSX.writeFile(workbook, `Ledger_${sanitizedCustomerLabel}.xlsx`);
    };


    return (

        <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '10px' }}>
            <h6
                className="uppercase tracking-wide text-black flex-grow linkcolor"
                style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}
            >
                Ledger
            </h6>
            {errorMessage && <p className="text-red-500">{errorMessage}</p>}

            <div className="w-full mb-2 flex" style={{ marginTop: '10px', justifyContent: 'space-between' }}>

                <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'left', marginTop: '-3px', justifyContent: 'space-between' }}>

                    <div style={{ paddingRight: '8px', marginBottom: '10px' }}>
                        {/* <label
                            style={{ color: 'Black', fontSize: '14px', fontWeight: 'bold', marginRight: '8px' }}
                            htmlFor="ledgerName"
                        >
                            Ledger Name
                        </label> */}
                        <label
                            className="block uppercase tracking-wide text-black text-xs font-bold mb-2"
                            htmlFor="fromDate"
                        >
                            Ledger Name
                        </label>
                        <AsyncSelect
                            cacheOptions
                            loadOptions={fetchChildOptions}
                            onInputChange={handleChildInputChange}
                            onChange={handleChildSelect}
                            value={selectedChildOption}
                            styles={{
                                menu: (provided) => ({
                                    ...provided,
                                    zIndex: 1301,
                                }),
                                control: (provided) => ({
                                    ...provided,
                                    width: '350px',
                                }),
                            }}
                        />

                    </div>

                    <div style={{ maxWidth: '150px', marginRight: '10px' }}>
                        <label
                            className="block uppercase tracking-wide text-black text-xs font-bold mb-2"
                            htmlFor="fromDate"
                        >
                            From Date
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            type="date"
                            value={fromDate}
                            onChange={handleFromDateChange}
                        />
                    </div>
                    <div style={{ maxWidth: '150px', marginRight: '10px' }}>
                        <label
                            className="block uppercase tracking-wide text-black text-xs font-bold mb-2"
                            htmlFor="toDate"
                        >
                            To Date
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            type="date"
                            value={toDate}
                            onChange={handleToDateChange}
                        />
                    </div>

                    <Button
                        style={{
                            background: 'linear-gradient(to right, #C7FFD8,#C7FFD8)',
                            borderRadius: '50px',
                            padding: '10px 20px',
                            color: '#0F0F0F',
                            fontWeight: 'bolder',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '35px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginLeft: '15px',
                            marginTop: '25px'
                        }}
                        onClick={fetchTableData}
                        className="linkcolor"
                    >
                        <span>Refresh</span>
                    </Button>

                    <Button
                        style={{
                            background: 'linear-gradient(to right, #98DED9,#98DED9)',
                            borderRadius: '50px',
                            padding: '10px 20px',
                            color: '#0F0F0F',
                            fontWeight: 'bolder',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '35px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginLeft: '10px',
                            marginTop: '25px'
                        }}
                        onClick={handleExportExcel}
                        className="linkcolor"
                    >
                        <span>Excel</span>
                    </Button>

                </div>

            </div>

            <div className='w-full mb-5 flex' style={{ maxHeight: '510px', overflowY: 'auto', marginTop: '-20px' }}>

                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#1F2544' }}>
                            <TableRow>
                                <TableCell sx={{ backgroundColor: '#1F2544', borderBottom: '1px solid #ddd', fontSize: '14px', color: 'whitesmoke', padding: '5px', fontWeight: 'bold' }}>Date</TableCell>
                                <TableCell sx={{ backgroundColor: '#1F2544', borderBottom: '1px solid #ddd', fontSize: '14px', color: 'whitesmoke', padding: '5px', fontWeight: 'bold' }}>Description</TableCell>
                                <TableCell sx={{ backgroundColor: '#1F2544', borderBottom: '1px solid #ddd', fontSize: '14px', color: 'whitesmoke', textAlign: 'right', padding: '5px', fontWeight: 'bold' }}>Debit</TableCell>
                                <TableCell sx={{ backgroundColor: '#1F2544', borderBottom: '1px solid #ddd', fontSize: '14px', color: 'whitesmoke', textAlign: 'right', padding: '5px', fontWeight: 'bold' }}>Credit</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {dataItem.map((data, index) => (
                                <TableRow key={data.id} sx={data.description1 === 'Opening Balance' || data.description1 === 'Closing Balance' || data.description1 === 'Total' ? { backgroundColor: '#C2D9FF' } : null}>

                                    {data.description1 === 'Opening Balance' || data.description1 === 'Closing Balance' || data.description1 === 'Total' ? (

                                        <TableCell sx={{ fontSize: '14px', padding: '7px', fontWeight: 'bolder' }}></TableCell>
                                    ) : (
                                        <TableCell sx={{ fontSize: '14px', padding: '7px' }}>{formatDate(data.date1)}</TableCell>
                                    )}



                                    <TableCell
                                        sx={{
                                            fontSize: '15px',
                                            height: '30px',
                                            padding: '11px',
                                            fontWeight:
                                                data.description1 === 'Opening Balance' ||
                                                    data.description1 === 'Closing Balance' ||
                                                    data.description1 === 'Total'
                                                    ? 'bolder'
                                                    : 'normal',
                                        }}
                                    >
                                        {data.tbl1 === 'Sale' ? (
                                            <a
                                                href={`/SaleDetails/${data.id}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ color: 'darkgreen' }}
                                            >
                                                {data.description1}
                                            </a>
                                        ) : data.tbl1 === 'Purchase' ? (
                                            <a
                                                href={`/PurchaseDetails/${data.id}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ color: 'darkblue' }}
                                            >
                                                {data.description1}
                                            </a>
                                        ) : data.tbl1 === 'PurchaseReturn' ? (
                                            <a
                                                href={`/PurchaseReturnDetails/${data.id}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ color: 'red' }}
                                            >
                                                {data.description1}
                                            </a>
                                        ) : data.tbl1 === 'SaleReturn' ? (
                                            <a
                                                href={`/SaleReturnDetails/${data.id}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ color: 'red' }}
                                            >
                                                {data.description1}
                                            </a>
                                        ) : (
                                            data.description1
                                        )}
                                    </TableCell>

                                    <TableCell sx={{ fontSize: '15px', height: '30px', padding: '11px', textAlign: 'right', fontWeight: data.description1 === 'Opening Balance' || data.description1 === 'Closing Balance' || data.description1 === 'Total' ? 'bolder' : 'normal' }}> {data.debit != null ? data.debit.toFixed(2) : ''}</TableCell>
                                    <TableCell sx={{ fontSize: '15px', height: '30px', padding: '11px', textAlign: 'right', fontWeight: data.description1 === 'Opening Balance' || data.description1 === 'Closing Balance' || data.description1 === 'Total' ? 'bolder' : 'normal' }}> {data.credit != null ? data.credit.toFixed(2) : ''}</TableCell>

                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

            </div>
        </div>
    );
}

export default LedgerReport;
